export default [
    {
      "value": "ALESSTHAN30",
      "comment": "LESS THAN 30"
    },
    {
      "value": "A30TO40",
      "comment": "30 TO 40"
    },
    {
      "value": "A41TO50",
      "comment": "41 TO 50 "
    },
    {
      "value": "A51TO60",
      "comment": "51 TO 60"
    },
    {
      "value": "AMORETHAN60",
      "comment": "MORE THAN 60"
    }
  ]